(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7966],{

/***/ 47017:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account",
      function () {
        return __webpack_require__(7826);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_polyglot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14408);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95348);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90757);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35843);
/* harmony import */ var _components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35007);
/* harmony import */ var _data_dictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9554);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28181);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);












var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()));
function FormTemplate(param) {
    var className = param.className, dictionary = param.dictionary, components = param.components, children = param.children;
    var ref;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var processedDictionary = (ref = Object.keys(dictionary)) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, lang) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, acc), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, lang, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, dictionary[lang]), {
            acceptsMarketing: t(_data_dictionary__WEBPACK_IMPORTED_MODULE_6__/* .FORM.ACCEPT_MARKETING */ .Yc.ACCEPT_MARKETING)
        })));
    }, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().FormTemplate)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_11__/* .TemplatesProvider */ .qi, {
            dictionary: processedDictionary,
            components: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                input: function(props) {
                    if ((props === null || props === void 0 ? void 0 : props.type) === "submit") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().submit),
                            type: "submit",
                            theme: _types_colors__WEBPACK_IMPORTED_MODULE_3__/* .GlobalThemeColors.Black */ .b.Black,
                            withBackground: true,
                            textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
                            children: props === null || props === void 0 ? void 0 : props.value
                        });
                    }
                    return null;
                }
            }, components),
            children: children
        })
    });
}
FormTemplate.defaultProps = {
    dictionary: _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
    components: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (FormTemplate);


/***/ }),

/***/ 11459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37444);
/* harmony import */ var _components_Abstracts_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87407);
/* harmony import */ var _providers_ThemeProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5672);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5114);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()));
function LoadingPage(param) {
    var color = param.color, className = param.className;
    var colors = (0,_providers_ThemeProvider__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)().colors;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loader), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().spinner),
            color: colors === null || colors === void 0 ? void 0 : colors[color !== null && color !== void 0 ? color : _types_colors__WEBPACK_IMPORTED_MODULE_3__/* .GlobalThemeColors.Black */ .b.Black]
        })
    });
}
LoadingPage.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingPage);


/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withAuthentication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96660);
/* harmony import */ var _components_Abstracts_LoadingPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11459);
/* harmony import */ var _hooks_account_useAuthentication__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87146);







function withAuthentication(WrappedComponent) {
    var HOC = function(pageProps) {
        var ref = (0,_hooks_account_useAuthentication__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SINGLE_ROUTES.login.href */ .OG.login.href, null), isInitialLoading = ref.isInitialLoading, customer = ref.data;
        return isInitialLoading || !customer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_LoadingPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    }, "robots")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, pageProps))
            ]
        });
    };
    return HOC;
}


/***/ }),

/***/ 87146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAuthentication; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98028);





function useAuthentication(redirectOnError, redirectOnSuccess) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        redirectOnError && router.prefetch(redirectOnError);
        redirectOnSuccess && router.prefetch(redirectOnSuccess);
    }, []);
    var _ref = (0,_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGetCustomer */ ._)({
        refetchOnMount: true,
        keepPreviousData: true,
        retry: 0,
        onSuccess: function(data) {
            data && redirectOnSuccess && router.replace(redirectOnSuccess);
            !data && redirectOnError && router.replace(redirectOnError);
        }
    }), fetchStatus = _ref.fetchStatus, isSuccess = _ref.isSuccess, profileQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "fetchStatus",
        "isSuccess"
    ]);
    var shouldRedirectOnError = fetchStatus === "idle" && redirectOnError && !(profileQuery === null || profileQuery === void 0 ? void 0 : profileQuery.data);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (shouldRedirectOnError) {
            redirectOnError && router.replace(redirectOnError);
        }
    }, [
        shouldRedirectOnError
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        isIdle: fetchStatus === "idle",
        isSuccess: isSuccess
    }, profileQuery);
}


/***/ }),

/***/ 7826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ account; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/customer/useGetCustomer/index.js + 1 modules
var useGetCustomer = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/customer/useGetCustomerAddresses/index.js + 1 modules
var useGetCustomerAddresses = __webpack_require__(85501);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/alert.ts
var _types_alert = __webpack_require__(34969);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/CustomerProvider/index.js + 1 modules
var CustomerProvider = __webpack_require__(15858);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/customer/useDeleteCustomerAddress/index.js + 1 modules
var useDeleteCustomerAddress = __webpack_require__(12933);
// EXTERNAL MODULE: ./src/components/Abstracts/LoadingComponent/index.tsx
var LoadingComponent = __webpack_require__(32528);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/templates/forms/UpdateCustomerAddressForm/index.js + 3 modules
var UpdateCustomerAddressForm = __webpack_require__(87514);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/templates/forms/CreateCustomerAddressForm/index.js + 2 modules
var CreateCustomerAddressForm = __webpack_require__(1518);
// EXTERNAL MODULE: ./src/components/Abstracts/FormTemplate/index.tsx
var FormTemplate = __webpack_require__(52791);
// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/providers/PopInProvider/index.tsx
var PopInProvider = __webpack_require__(18286);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/account/useCustomerErrors/index.ts
var useCustomerErrors = __webpack_require__(99713);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts
var useAlerts = __webpack_require__(827);
// EXTERNAL MODULE: ./src/components/Account/Logged/AddressBook/AddressForm/styles.module.scss
var styles_module = __webpack_require__(81001);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/AddressBook/AddressForm/index.tsx













var cx = bind_default().bind((styles_module_default()));
function AddressForm(param) {
    var className = param.className, title = param.title, update = param.update, address = param.address;
    var removeCurrent = (0,PopInProvider/* usePopIn */.wG)().removeCurrent;
    var onError = (0,useCustomerErrors/* default */.Z)();
    var triggerAlert = (0,useAlerts/* default */.Z)();
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        color: colors/* GlobalThemeColors.Black */.b.Black,
        textPreset: text_preset/* GlobalTextPreset.Title24SangBleuLight */.C.Title24SangBleuLight
    });
    var handleSuccess = function() {
        removeCurrent();
        triggerAlert(_types_alert/* ALERT_CODES.ENTITY_SAVED */.p.ENTITY_SAVED);
    };
    var mutationOptions = {
        onSuccess: handleSuccess,
        onError: function(error) {
            var ref;
            var ref1 = onError(error), errsGlobals = ref1.errsGlobals, errsFields = ref1.errsFields;
            var errors = Object.values(errsGlobals);
            if (errors === null || errors === void 0 ? void 0 : errors.length) {
                errors.map(triggerAlert);
            }
            if (!(errors === null || errors === void 0 ? void 0 : errors.length) && !((ref = Object.values(errsFields)) === null || ref === void 0 ? void 0 : ref.length)) {
                triggerAlert();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).AddressForm, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                className: cx((styles_module_default()).title, titleStyle),
                render: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTemplate/* default */.Z, {
                className: (styles_module_default()).form,
                children: update ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateCustomerAddressForm/* UpdateCustomerAddressForm */.o, {
                    addressId: address === null || address === void 0 ? void 0 : address.id,
                    mutationOptions: mutationOptions
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateCustomerAddressForm/* CreateCustomerAddressForm */.h, {
                    mutationOptions: mutationOptions
                })
            })
        ]
    });
}
AddressForm.defaultProps = {};
/* harmony default export */ var AddressBook_AddressForm = (AddressForm);

// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
;// CONCATENATED MODULE: ./src/utils/join-texts.ts
function joinTexts(values, delimiter) {
    var texts = values.filter(function(text) {
        return text && typeof text === "string" && text !== "";
    });
    return (texts === null || texts === void 0 ? void 0 : texts.length) ? texts.join(delimiter) : null;
}

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/Account/Logged/AddressBook/AdressItem/styles.module.scss
var AdressItem_styles_module = __webpack_require__(2144);
var AdressItem_styles_module_default = /*#__PURE__*/__webpack_require__.n(AdressItem_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/AddressBook/AdressItem/index.tsx




















var PopIn = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9285).then(__webpack_require__.bind(__webpack_require__, 9285));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9285)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComponent/* default */.Z, {});
    }
});
var AdressItem_cx = bind_default().bind((AdressItem_styles_module_default()));
var computedText = function(values) {
    return joinTexts(values, " ");
};
function AddressItem(_param) {
    var className = _param.className, isAdd = _param.isAdd, isDefault = _param.isDefault, addAddressTitle = _param.addAddressTitle, updateAddressTitle = _param.updateAddressTitle, address = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isAdd",
        "isDefault",
        "addAddressTitle",
        "updateAddressTitle"
    ]);
    var id = address.id, firstName = address.firstName, lastName = address.lastName, address1 = address.address1, city = address.city, zip = address.zip, country = address.country, phone = address.phone;
    var customerAccessToken = (0,CustomerProvider/* useCustomerContext */.jt)().customerAccessToken;
    var t = (0,lib/* useTranslate */.qM)();
    var linkStyle = (0,StyleProvider/* useStyle */.X)({
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black,
        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk
    });
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var add = (0,PopInProvider/* usePopIn */.wG)().add;
    var triggerAlert = (0,useAlerts/* default */.Z)();
    var mutate = (0,useDeleteCustomerAddress/* useDeleteCustomerAddress */.b)({
        onSuccess: function() {
            return triggerAlert(_types_alert/* ALERT_CODES.ENTITY_SAVED */.p.ENTITY_SAVED);
        },
        onError: function() {
            triggerAlert(_types_alert/* ALERT_CODES.SERVER_ERROR */.p.SERVER_ERROR);
        }
    }).mutate;
    var handleAddressPopinAction = function(props) {
        add(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopIn, {
            className: AdressItem_cx((AdressItem_styles_module_default()).AddressPopin, (AdressItem_styles_module_default()).popin),
            isCloseButton: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressBook_AddressForm, (0,_object_spread/* default */.Z)({
                className: (AdressItem_styles_module_default()).addressForm,
                title: (props === null || props === void 0 ? void 0 : props.update) ? updateAddressTitle : addAddressTitle
            }, props !== null && props !== void 0 ? props : {}))
        }));
    };
    var computedFullName = computedText([
        firstName,
        lastName
    ]);
    var computedCity = computedText([
        zip,
        city
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (AdressItem_styles_module_default()).wrapper,
        children: [
            isAdd && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: AdressItem_cx(linkStyle, (AdressItem_styles_module_default()).placeHolderLink),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t(dictionary/* ACCOUNT.ADD_ADDRESS */.yV.ADD_ADDRESS)
                        }),
                        "(+)"
                    ]
                })
            }),
            !isAdd && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: AdressItem_cx((AdressItem_styles_module_default()).empty)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: AdressItem_cx((AdressItem_styles_module_default()).content),
                        children: [
                            computedFullName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: textStyle,
                                children: computedFullName
                            }),
                            address1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: textStyle,
                                children: address1
                            }),
                            computedCity && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: textStyle,
                                children: computedCity
                            }),
                            country && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: textStyle,
                                children: country
                            }),
                            phone && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: textStyle,
                                children: phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: AdressItem_cx((AdressItem_styles_module_default()).buttons),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                                className: AdressItem_cx(linkStyle, (AdressItem_styles_module_default()).link),
                                onClick: function() {
                                    handleAddressPopinAction({
                                        update: true,
                                        address: address
                                    });
                                },
                                children: t(dictionary/* ACCOUNT.EDIT_ADDRESS */.yV.EDIT_ADDRESS)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                                className: AdressItem_cx(linkStyle, (AdressItem_styles_module_default()).link),
                                onClick: function() {
                                    return mutate({
                                        id: id,
                                        customerAccessToken: customerAccessToken
                                    });
                                },
                                children: t(dictionary/* ACCOUNT.DELETE_ADDRESS */.yV.DELETE_ADDRESS)
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return isAdd ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: AdressItem_cx((AdressItem_styles_module_default()).AddressItem, className, (AdressItem_styles_module_default()).ratio, {
            isAdd: isAdd
        }),
        onClick: function() {
            handleAddressPopinAction({});
        },
        children: content
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: AdressItem_cx((AdressItem_styles_module_default()).AddressItem, className, (AdressItem_styles_module_default()).ratio, {
            isAdd: isAdd
        }),
        children: content
    });
}
AddressItem.defaultProps = {
    isAdd: false
};
/* harmony default export */ var AdressItem = (AddressItem);

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Spinner/index.js
var Spinner = __webpack_require__(38137);
// EXTERNAL MODULE: ./src/components/Account/Logged/LoadingSection/styles.module.scss
var LoadingSection_styles_module = __webpack_require__(2389);
var LoadingSection_styles_module_default = /*#__PURE__*/__webpack_require__.n(LoadingSection_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/LoadingSection/index.tsx





var LoadingSection_cx = bind_default().bind((LoadingSection_styles_module_default()));
function LoadingSection(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: LoadingSection_cx(className, (LoadingSection_styles_module_default()).LoadingSection),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
            className: (LoadingSection_styles_module_default()).spinner
        })
    });
}
LoadingSection.defaultProps = {};
/* harmony default export */ var Logged_LoadingSection = (LoadingSection);

// EXTERNAL MODULE: ./src/components/Account/Logged/SectionTitle/styles.module.scss
var SectionTitle_styles_module = __webpack_require__(84657);
var SectionTitle_styles_module_default = /*#__PURE__*/__webpack_require__.n(SectionTitle_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/SectionTitle/index.tsx







var SectionTitle_cx = bind_default().bind((SectionTitle_styles_module_default()));
function SectionTitle(param) {
    var className = param.className, title = param.title;
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title24SangBleuLight */.C.Title24SangBleuLight,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
        className: SectionTitle_cx(className, (SectionTitle_styles_module_default()).SectionTitle, titleStyle),
        render: title
    });
}
SectionTitle.defaultProps = {};
/* harmony default export */ var Logged_SectionTitle = (SectionTitle);

// EXTERNAL MODULE: ./src/components/Account/Logged/AddressBook/styles.module.scss
var AddressBook_styles_module = __webpack_require__(18287);
var AddressBook_styles_module_default = /*#__PURE__*/__webpack_require__.n(AddressBook_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/AddressBook/index.tsx











var AddressBook_cx = bind_default().bind((AddressBook_styles_module_default()));
function AddressBook(_param) {
    var className = _param.className, title = _param.title, titles = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "title"
    ]);
    var ref = (0,useGetCustomerAddresses/* useGetCustomerAddresses */.u)(), data = ref.data, isLoading = ref.isLoading;
    var addresses = (data !== null && data !== void 0 ? data : {}).addresses;
    var customSliderRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: AddressBook_cx((AddressBook_styles_module_default()).Addresses, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_SectionTitle, {
                title: title
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_LoadingSection, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: AddressBook_cx((AddressBook_styles_module_default()).content),
                children: [
                    (addresses === null || addresses === void 0 ? void 0 : addresses.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdressItem, (0,_object_spread/* default */.Z)({
                        className: AddressBook_cx((AddressBook_styles_module_default()).item, (AddressBook_styles_module_default()).hideOnSmallScreen),
                        isAdd: true
                    }, titles)),
                    (addresses === null || addresses === void 0 ? void 0 : addresses.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* default */.ZP, {
                        className: AddressBook_cx((AddressBook_styles_module_default()).slider, (AddressBook_styles_module_default()).hideOnSmallScreen),
                        snap: true,
                        customSliderRef: customSliderRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdressItem, (0,_object_spread/* default */.Z)({
                                className: AddressBook_cx((AddressBook_styles_module_default()).item),
                                isAdd: true
                            }, titles)),
                            addresses === null || addresses === void 0 ? void 0 : addresses.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdressItem, (0,_object_spread/* default */.Z)({
                                    className: AddressBook_cx((AddressBook_styles_module_default()).item)
                                }, titles, item), "item_".concat(key));
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: AddressBook_cx((AddressBook_styles_module_default()).mobileCards, (AddressBook_styles_module_default()).hideOnLargeScreen),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdressItem, (0,_object_spread/* default */.Z)({
                                className: AddressBook_cx((AddressBook_styles_module_default()).item),
                                isAdd: true
                            }, titles)),
                            (addresses === null || addresses === void 0 ? void 0 : addresses.length) > 0 && (addresses === null || addresses === void 0 ? void 0 : addresses.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdressItem, (0,_object_spread/* default */.Z)({
                                    className: AddressBook_cx((AddressBook_styles_module_default()).item)
                                }, titles, item), "item_".concat(key));
                            }))
                        ]
                    })
                ]
            })
        ]
    });
}
AddressBook.defaultProps = {};
/* harmony default export */ var Logged_AddressBook = (AddressBook);

// EXTERNAL MODULE: ./src/components/Account/Logged/Hero/styles.module.scss
var Hero_styles_module = __webpack_require__(29305);
var Hero_styles_module_default = /*#__PURE__*/__webpack_require__.n(Hero_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Hero/index.tsx







var Hero_cx = bind_default().bind((Hero_styles_module_default()));
function AccountHero(param) {
    var className = param.className, greeting = param.greeting, name = param.name;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title30_40SangBleu */.C.Title30_40SangBleu,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: Hero_cx(className, (Hero_styles_module_default()).AccountHero, gridStyle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Hero_styles_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: titleStyle,
                children: [
                    greeting,
                    name ? ", ".concat(name) : ""
                ]
            })
        })
    });
}
AccountHero.defaultProps = {};
/* harmony default export */ var Hero = (AccountHero);

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/templates/forms/UpdateCustomerForm/index.js + 2 modules
var UpdateCustomerForm = __webpack_require__(92573);
// EXTERNAL MODULE: ./src/components/Account/Logged/InformationAndChangePassword/Information/styles.module.scss
var Information_styles_module = __webpack_require__(75142);
var Information_styles_module_default = /*#__PURE__*/__webpack_require__.n(Information_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/InformationAndChangePassword/Information/index.tsx









var Information_cx = bind_default().bind((Information_styles_module_default()));
function Information(param) {
    var className = param.className, title = param.title;
    var onError = (0,useCustomerErrors/* default */.Z)();
    var triggerAlert = (0,useAlerts/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Information_cx((Information_styles_module_default()).Information, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_SectionTitle, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTemplate/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateCustomerForm/* UpdateCustomerForm */.V, {
                    mutationOptions: {
                        onSuccess: function() {
                            return triggerAlert(_types_alert/* ALERT_CODES.ENTITY_SAVED */.p.ENTITY_SAVED);
                        },
                        onError: function(error) {
                            var ref;
                            var ref1 = onError(error), errsGlobals = ref1.errsGlobals, errsFields = ref1.errsFields;
                            var errors = Object.values(errsGlobals);
                            if (errors === null || errors === void 0 ? void 0 : errors.length) {
                                errors.map(triggerAlert);
                            }
                            if (!(errors === null || errors === void 0 ? void 0 : errors.length) && !((ref = Object.values(errsFields)) === null || ref === void 0 ? void 0 : ref.length)) {
                                triggerAlert();
                            }
                        }
                    }
                })
            })
        ]
    });
}
Information.defaultProps = {};
/* harmony default export */ var InformationAndChangePassword_Information = (Information);

// EXTERNAL MODULE: ./src/components/Account/Logged/InformationAndChangePassword/styles.module.scss
var InformationAndChangePassword_styles_module = __webpack_require__(27329);
var InformationAndChangePassword_styles_module_default = /*#__PURE__*/__webpack_require__.n(InformationAndChangePassword_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/InformationAndChangePassword/index.tsx





var InformationAndChangePassword_cx = bind_default().bind((InformationAndChangePassword_styles_module_default()));
function InformationAndChangePassword(param) {
    var className = param.className, customer = param.customer, information = param.information;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: InformationAndChangePassword_cx(className, (InformationAndChangePassword_styles_module_default()).InformationAndChangePassword),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationAndChangePassword_Information, (0,_object_spread/* default */.Z)({
            customer: customer
        }, information))
    });
}
InformationAndChangePassword.defaultProps = {};
/* harmony default export */ var Logged_InformationAndChangePassword = (InformationAndChangePassword);

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/customer/useLogout/index.js
var useLogout = __webpack_require__(23228);
// EXTERNAL MODULE: ./src/hooks/useSingleRoutesRedirect/index.ts
var useSingleRoutesRedirect = __webpack_require__(31569);
// EXTERNAL MODULE: ./src/components/Account/Logged/Navigation/styles.module.scss
var Navigation_styles_module = __webpack_require__(94224);
var Navigation_styles_module_default = /*#__PURE__*/__webpack_require__.n(Navigation_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Navigation/index.tsx











var Navigation_cx = bind_default().bind((Navigation_styles_module_default()));
var AccountNavigationSections = {
    ADDRESS_BOOK: "address-book",
    INFORMATION: "information",
    LOGOUT: "logout",
    ORDERS: "orders",
    RETURNS: "returns"
};
function AccountNavigation(param) {
    var className = param.className, activeSection = param.activeSection, setSection = param.setSection, items = param.items;
    var t = (0,lib/* useTranslate */.qM)();
    var redirect = (0,useSingleRoutesRedirect/* default */.Z)();
    var handleLogout = (0,useLogout/* useLogout */.a)({
        onLogout: function() {
            return redirect(constants/* SINGLE_ROUTES.login */.OG.login);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: Navigation_cx(className, (Navigation_styles_module_default()).AccountNavigation),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (Navigation_styles_module_default()).links,
            children: [
                items === null || items === void 0 ? void 0 : items.map(function(param) {
                    var label = param.label, section = param.section;
                    var isActive = activeSection && activeSection === section;
                    var theme = isActive ? colors/* GlobalThemeColors.Black */.b.Black : colors/* GlobalThemeColors.Gray */.b.Gray;
                    var Tag = isActive ? "h1" : "span";
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (Navigation_styles_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                            onClick: function() {
                                return setSection(section);
                            },
                            textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                            theme: theme,
                            lineProps: {
                                initialLineState: "none"
                            },
                            forcedUnderlined: isActive,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                children: label
                            })
                        })
                    }, "accountNavigationItem".concat(screen).concat(section).concat(activeSection));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (Navigation_styles_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                        lineProps: {
                            initialLineState: "none"
                        },
                        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                        theme: colors/* GlobalThemeColors.Gray */.b.Gray,
                        onClick: handleLogout,
                        children: t(dictionary/* ACCOUNT.LOGOUT */.yV.LOGOUT)
                    })
                })
            ]
        })
    });
}
AccountNavigation.defaultProps = {};
/* harmony default export */ var Navigation = (AccountNavigation);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/index.js
var Accordion = __webpack_require__(99385);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/AccordionPanel/index.js
var AccordionPanel = __webpack_require__(4903);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/customer/useGetCustomerOrders/index.js + 3 modules
var useGetCustomerOrders = __webpack_require__(51893);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
// EXTERNAL MODULE: ./src/components/Account/Logged/EmptySection/styles.module.scss
var EmptySection_styles_module = __webpack_require__(89634);
var EmptySection_styles_module_default = /*#__PURE__*/__webpack_require__.n(EmptySection_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/EmptySection/index.tsx








var EmptySection_cx = bind_default().bind((EmptySection_styles_module_default()));
function EmptySection(param) {
    var className = param.className, link = param.link, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: EmptySection_cx((EmptySection_styles_module_default()).EmptySection, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_SectionTitle, {
                className: (EmptySection_styles_module_default()).title,
                title: title
            }),
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, (0,_object_spread/* default */.Z)({
                className: EmptySection_cx((EmptySection_styles_module_default()).cta),
                theme: colors/* GlobalThemeColors.Black */.b.Black,
                withBackground: true
            }, link))
        ]
    });
}
EmptySection.defaultProps = {};
/* harmony default export */ var Logged_EmptySection = (EmptySection);

// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/Account/Logged/Orders/OrderDetails/OrderProducts/styles.module.scss
var OrderProducts_styles_module = __webpack_require__(73420);
var OrderProducts_styles_module_default = /*#__PURE__*/__webpack_require__.n(OrderProducts_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Orders/OrderDetails/OrderProducts/index.tsx










var OrderProducts_cx = bind_default().bind((OrderProducts_styles_module_default()));
var IMAGE_SIZES = [
    {
        breakpoint: "lg",
        ratio: 4 / 24
    },
    {
        ratio: 4 / 16
    }
];
function OrderProducts(param) {
    var className = param.className, products = param.products;
    var t = (0,lib/* useTranslate */.qM)();
    var designerStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title15SangBleu */.C.Title15SangBleu,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var labelStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label10Grotesk */.C.Label10Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Gray */.b.Gray
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: OrderProducts_cx(className, (OrderProducts_styles_module_default()).OrderProducts),
        children: products === null || products === void 0 ? void 0 : products.map(function(product, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: OrderProducts_cx((OrderProducts_styles_module_default()).product),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OrderProducts_styles_module_default()).imageWrapper,
                        children: [
                            (product === null || product === void 0 ? void 0 : product.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                className: (OrderProducts_styles_module_default()).image,
                                ratio: (OrderProducts_styles_module_default()).ratio,
                                sizesFromBreakpoints: IMAGE_SIZES,
                                layout: "fill",
                                objectFit: "cover",
                                asPlaceholder: true,
                                src: product.image
                            }),
                            (product === null || product === void 0 ? void 0 : product.sku) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: labelStyle,
                                children: product.sku
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: OrderProducts_cx(textStyle, (OrderProducts_styles_module_default()).details),
                        children: [
                            (product === null || product === void 0 ? void 0 : product.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: OrderProducts_cx(designerStyle, (OrderProducts_styles_module_default()).designer),
                                children: product.label
                            }),
                            (product === null || product === void 0 ? void 0 : product.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: OrderProducts_cx((OrderProducts_styles_module_default()).name),
                                children: product.name
                            }),
                            (product === null || product === void 0 ? void 0 : product.quantity) && (product === null || product === void 0 ? void 0 : product.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (OrderProducts_styles_module_default()).priceAndQuantity,
                                children: [
                                    product.quantity,
                                    " x ",
                                    product.price
                                ]
                            }),
                            !(product === null || product === void 0 ? void 0 : product.isUniqueSize) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (OrderProducts_styles_module_default()).sizeWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t(dictionary/* ACCOUNT.ORDER_SIZE */.yV.ORDER_SIZE)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (OrderProducts_styles_module_default()).size,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: product === null || product === void 0 ? void 0 : product.size
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "orderDetailsProductItem".concat(index));
        })
    });
}
OrderProducts.defaultProps = {};
/* harmony default export */ var OrderDetails_OrderProducts = (OrderProducts);

// EXTERNAL MODULE: ./src/components/Account/Logged/Orders/OrderDetails/styles.module.scss
var OrderDetails_styles_module = __webpack_require__(14180);
var OrderDetails_styles_module_default = /*#__PURE__*/__webpack_require__.n(OrderDetails_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Orders/OrderDetails/index.tsx











var OrderDetails_cx = bind_default().bind((OrderDetails_styles_module_default()));
function OrderDetails(param) {
    var className = param.className, products = param.products, date = param.date, shippingPrice = param.shippingPrice, shippingAddress = param.shippingAddress, paymentDetails = param.paymentDetails, isLoading = param.isLoading, total = param.total, status = param.status;
    var t = (0,lib/* useTranslate */.qM)();
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        color: colors/* GlobalThemeColors.Black */.b.Black,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var renderPartial = function(param) {
        var key = param.key, value = param.value;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (OrderDetails_styles_module_default()).partial,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: OrderDetails_cx((OrderDetails_styles_module_default()).title, textStyle),
                    children: t(key)
                }),
                value && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: value
                })
            ]
        });
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: OrderDetails_cx((OrderDetails_styles_module_default()).OrderDetails, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderDetails_OrderProducts, {
                className: (OrderDetails_styles_module_default()).products,
                products: products
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: OrderDetails_cx(textStyle, (OrderDetails_styles_module_default()).instructions),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            renderPartial({
                                key: dictionary/* ACCOUNT.ORDER_SHIPPING_PRICE */.yV.ORDER_SHIPPING_PRICE,
                                value: shippingPrice
                            }),
                            renderPartial({
                                key: dictionary/* ACCOUNT.TOTAL */.yV.TOTAL,
                                value: total
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: OrderDetails_cx((OrderDetails_styles_module_default()).partialWrapper, (OrderDetails_styles_module_default()).billing),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (OrderDetails_styles_module_default()).partial,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: OrderDetails_cx((OrderDetails_styles_module_default()).title, textStyle),
                                    children: t(dictionary/* ACCOUNT.ORDER_BILLING_DETAILS */.yV.ORDER_BILLING_DETAILS)
                                }),
                                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                                    className: (OrderDetails_styles_module_default()).spinner
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (OrderDetails_styles_module_default()).content,
                                    children: [
                                        (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.formattedGateway) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: OrderDetails_cx((OrderDetails_styles_module_default()).contentLine),
                                            children: paymentDetails.formattedGateway
                                        }),
                                        (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.accountNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: OrderDetails_cx((OrderDetails_styles_module_default()).contentLine),
                                            children: paymentDetails.accountNumber
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OrderDetails_styles_module_default()).partialWrapper,
                        children: renderPartial({
                            key: dictionary/* ACCOUNT.CUSTOMER */.yV.CUSTOMER,
                            value: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (OrderDetails_styles_module_default()).partialWrapper,
                        children: [
                            renderPartial({
                                key: dictionary/* ACCOUNT.DATE */.yV.DATE,
                                value: date
                            }),
                            renderPartial({
                                key: dictionary/* ACCOUNT.ORDER_STATUS */.yV.ORDER_STATUS,
                                value: (ref = dictionary/* ORDER */.kl === null || dictionary/* ORDER */.kl === void 0 ? void 0 : dictionary/* ORDER */.kl["STATUS_".concat(status === null || status === void 0 ? void 0 : status.toUpperCase())]) !== null && ref !== void 0 ? ref : dictionary/* ORDER.STATUS_UNKNOWN */.kl.STATUS_UNKNOWN
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Orders_OrderDetails = (OrderDetails);

// EXTERNAL MODULE: ./src/components/Account/Logged/Orders/OrderHead/styles.module.scss
var OrderHead_styles_module = __webpack_require__(62170);
var OrderHead_styles_module_default = /*#__PURE__*/__webpack_require__.n(OrderHead_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Orders/OrderHead/index.tsx









var OrderHead_cx = bind_default().bind((OrderHead_styles_module_default()));
function OrderHead(param) {
    var className = param.className, isActive = param.isActive, reference = param.reference, date = param.date;
    var t = (0,lib/* useTranslate */.qM)();
    var labelStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var actionStyle = (0,StyleProvider/* useStyle */.X)({
        textStyling: text_styling/* GlobalTextStyling.Medium */.l.Medium,
        color: isActive ? colors/* GlobalThemeColors.Gray */.b.Gray : colors/* GlobalThemeColors.Black */.b.Black
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: OrderHead_cx(className, (OrderHead_styles_module_default()).OrderHead, labelStyle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    t(dictionary/* ACCOUNT.ORDER */.yV.ORDER),
                    " ",
                    reference,
                    " - ",
                    date
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: OrderHead_cx((OrderHead_styles_module_default()).cta, actionStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: isActive ? t(dictionary/* ACCOUNT.CLOSE */.yV.CLOSE) : t(dictionary/* ACCOUNT.VIEW_ORDER */.yV.VIEW_ORDER)
                    }),
                    "(",
                    isActive ? "-" : "+",
                    ")"
                ]
            })
        ]
    });
}
OrderHead.defaultProps = {};
/* harmony default export */ var Orders_OrderHead = (OrderHead);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/lib/handle-api.ts + 1 modules
var handle_api = __webpack_require__(16445);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
;// CONCATENATED MODULE: ./src/hooks/account/useGetAdminOrder/index.ts







function useGetAdminOrder(orderId) {
    var locale = (0,useLocale/* default */.Z)();
    var customerAccessToken = (0,CustomerProvider/* useCustomerContext */.jt)().customerAccessToken;
    return (0,useQuery/* useQuery */.a)([
        constants/* QUERY_KEYS.ORDER_ADMIN */.U7.ORDER_ADMIN,
        orderId
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, response, ref1, transactions, paymentDetails;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,handle_api/* requestNextApiEndpoint */.m8)(handle_api/* SHOPIFY_ADMIN_ORDER_PARAMS */.NT, {
                            accessToken: customerAccessToken,
                            queryParams: {
                                id: orderId,
                                locale: locale
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    transactions = ((ref1 = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.order) !== null && ref1 !== void 0 ? ref1 : {}).transactions;
                    paymentDetails = transactions === null || transactions === void 0 ? void 0 : transactions.find(function(t) {
                        return t === null || t === void 0 ? void 0 : t.formattedGateway;
                    });
                    return [
                        2,
                        {
                            paymentDetails: paymentDetails
                        }
                    ];
            }
        });
    }), {
        enabled: Boolean(orderId),
        keepPreviousData: true,
        staleTime: 10000
    });
}

// EXTERNAL MODULE: ./src/lib/link-resolver.ts + 3 modules
var link_resolver = __webpack_require__(3523);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/utils/attributes.ts
var attributes = __webpack_require__(44335);
// EXTERNAL MODULE: ./src/utils/locales.ts
var locales = __webpack_require__(40457);
// EXTERNAL MODULE: ./src/data/serialize-price.ts
var serialize_price = __webpack_require__(99338);
;// CONCATENATED MODULE: ./src/data/serialize-order.ts








function serializeOrder(param) {
    var order = param.order, locale = param.locale;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var intl = (0,locales/* getIntlLocale */.eY)(locale);
    var ref7;
    var products = order === null || order === void 0 ? void 0 : (ref = order.lineItems) === null || ref === void 0 ? void 0 : ref.map(function(product) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
            customAttributes: (0,attributes/* attributesAsObject */.A)((ref7 = product === null || product === void 0 ? void 0 : product.customAttributes) !== null && ref7 !== void 0 ? ref7 : [])
        });
    });
    var ref8, ref9, ref10;
    return {
        id: order === null || order === void 0 ? void 0 : order.id,
        reference: order === null || order === void 0 ? void 0 : (ref1 = order.name) === null || ref1 === void 0 ? void 0 : ref1.replace(/#/g, ""),
        date: (order === null || order === void 0 ? void 0 : order.processedAt) ? (ref2 = new Intl.DateTimeFormat(intl).format(new Date(order === null || order === void 0 ? void 0 : order.processedAt))) === null || ref2 === void 0 ? void 0 : ref2.replace(/\//g, ".") : null,
        total: (ref8 = (0,serialize_price/* default */.Z)(locale, order === null || order === void 0 ? void 0 : (ref3 = order.totalPrice) === null || ref3 === void 0 ? void 0 : ref3.currencyCode, order === null || order === void 0 ? void 0 : (ref4 = order.totalPrice) === null || ref4 === void 0 ? void 0 : ref4.amount)) !== null && ref8 !== void 0 ? ref8 : null,
        status: order === null || order === void 0 ? void 0 : order.fulfillmentStatus,
        shippingPrice: (ref9 = (0,serialize_price/* default */.Z)(locale, order === null || order === void 0 ? void 0 : (ref5 = order.totalShippingPrice) === null || ref5 === void 0 ? void 0 : ref5.currencyCode, order === null || order === void 0 ? void 0 : (ref6 = order.totalShippingPrice) === null || ref6 === void 0 ? void 0 : ref6.amount)) !== null && ref9 !== void 0 ? ref9 : null,
        shippingAddress: (ref10 = order === null || order === void 0 ? void 0 : order.shippingAddress) !== null && ref10 !== void 0 ? ref10 : null,
        products: products === null || products === void 0 ? void 0 : products.map(function(product) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            var ref12, ref13, ref14, ref15;
            return {
                id: product === null || product === void 0 ? void 0 : (ref = product.variant) === null || ref === void 0 ? void 0 : ref.id,
                sku: product === null || product === void 0 ? void 0 : (ref1 = product.variant) === null || ref1 === void 0 ? void 0 : ref1.sku,
                isUniqueSize: (ref12 = Boolean(product === null || product === void 0 ? void 0 : (ref2 = product.customAttributes) === null || ref2 === void 0 ? void 0 : ref2._isUniqueSize)) !== null && ref12 !== void 0 ? ref12 : false,
                name: (ref13 = product === null || product === void 0 ? void 0 : (ref3 = product.customAttributes) === null || ref3 === void 0 ? void 0 : ref3[constants/* SHOPIFY_ATTRIBUTES.name */.n1.name]) !== null && ref13 !== void 0 ? ref13 : null,
                href: (0,link_resolver/* default */.Z)({
                    content: {
                        component: storyblok_types/* STORYBLOK_TYPES.PRODUCT */.nI.PRODUCT
                    },
                    slug: product === null || product === void 0 ? void 0 : (ref4 = product.customAttributes) === null || ref4 === void 0 ? void 0 : ref4[constants/* SHOPIFY_ATTRIBUTES.slug */.n1.slug]
                }),
                size: product === null || product === void 0 ? void 0 : (ref5 = product.variant) === null || ref5 === void 0 ? void 0 : ref5.title,
                image: (ref14 = product === null || product === void 0 ? void 0 : (ref6 = product.customAttributes) === null || ref6 === void 0 ? void 0 : ref6[constants/* SHOPIFY_ATTRIBUTES.image */.n1.image]) !== null && ref14 !== void 0 ? ref14 : null,
                label: (ref15 = product === null || product === void 0 ? void 0 : (ref7 = product.customAttributes) === null || ref7 === void 0 ? void 0 : ref7[constants/* SHOPIFY_ATTRIBUTES.designer */.n1.designer]) !== null && ref15 !== void 0 ? ref15 : null,
                price: (0,serialize_price/* default */.Z)(locale, product === null || product === void 0 ? void 0 : (ref8 = product.originalTotalPrice) === null || ref8 === void 0 ? void 0 : ref8.currencyCode, product === null || product === void 0 ? void 0 : (ref9 = product.originalTotalPrice) === null || ref9 === void 0 ? void 0 : ref9.amount),
                quantity: product === null || product === void 0 ? void 0 : product.quantity,
                total: (0,serialize_price/* default */.Z)(locale, product === null || product === void 0 ? void 0 : (ref10 = product.originalTotalPrice) === null || ref10 === void 0 ? void 0 : ref10.currencyCode, (product === null || product === void 0 ? void 0 : (ref11 = product.originalTotalPrice) === null || ref11 === void 0 ? void 0 : ref11.amount) * (product === null || product === void 0 ? void 0 : product.quantity))
            };
        })
    };
}

// EXTERNAL MODULE: ./src/components/Account/Logged/Orders/styles.module.scss
var Orders_styles_module = __webpack_require__(40289);
var Orders_styles_module_default = /*#__PURE__*/__webpack_require__.n(Orders_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Orders/index.tsx

















var Orders_cx = bind_default().bind((Orders_styles_module_default()));
function Orders(param) {
    var className = param.className, emptyTitle = param.emptyTitle, emptyLink = param.emptyLink, title = param.title, orders = param.orders, isLoading = param.isLoading;
    var ref = (0,react.useState)(null), orderId = ref[0], setOrderId = ref[1];
    var hasOrders = (orders === null || orders === void 0 ? void 0 : orders.length) > 0;
    var ref1 = useGetAdminOrder(orderId), adminOrder = ref1.data, adminOrderIsLoading = ref1.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Orders_cx((Orders_styles_module_default()).Orders, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_SectionTitle, {
                title: title
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_LoadingSection, {}) : hasOrders ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.UQ, {
                    className: Orders_cx((Orders_styles_module_default()).accordion),
                    children: orders === null || orders === void 0 ? void 0 : orders.map(function(_param, index) {
                        var id = _param.id, order = (0,_object_without_properties/* default */.Z)(_param, [
                            "id"
                        ]);
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(AccordionPanel/* AccordionPanel */.H, {
                            index: index,
                            head: function(isActive) {
                                if (isActive) {
                                    setOrderId(id);
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Orders_OrderHead, (0,_object_spread/* default */.Z)({
                                    className: (Orders_styles_module_default()).row,
                                    isActive: isActive
                                }, order));
                            },
                            body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Orders_OrderDetails, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, order), {
                                className: (Orders_styles_module_default()).orderDetails,
                                paymentDetails: adminOrder === null || adminOrder === void 0 ? void 0 : adminOrder.paymentDetails,
                                isLoading: adminOrderIsLoading
                            }))
                        }, "orderRow".concat(id, "_").concat(index));
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_EmptySection, {
                    title: emptyTitle,
                    link: emptyLink
                })
            })
        ]
    });
}
Orders.defaultProps = {};
function OrdersWrapper(props) {
    var locale = (0,useLocale/* default */.Z)();
    var ref = (0,useGetCustomerOrders/* useGetCustomerOrders */.d)({
        ordersAmount: 20
    }), data = ref.data, isLoading = ref.isLoading;
    var orders = (0,react.useMemo)(function() {
        var ref, ref1;
        return data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.map(function(order) {
            return serializeOrder({
                locale: locale,
                order: order
            });
        });
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Orders, (0,_object_spread/* default */.Z)({
        isLoading: isLoading,
        orders: orders
    }, props));
}

// EXTERNAL MODULE: ./src/components/Account/Logged/Returns/styles.module.scss
var Returns_styles_module = __webpack_require__(57175);
var Returns_styles_module_default = /*#__PURE__*/__webpack_require__.n(Returns_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/Returns/index.tsx








var Returns_cx = bind_default().bind((Returns_styles_module_default()));
function Returns(param) {
    var className = param.className, title = param.title, text = param.text;
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text14GroteskRegular */.C.Text14GroteskRegular,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: Returns_cx(className, (Returns_styles_module_default()).Returns),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_SectionTitle, {
                className: (Returns_styles_module_default()).title,
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                className: textStyle,
                render: text
            })
        ]
    });
}
Returns.defaultProps = {};
/* harmony default export */ var Logged_Returns = (Returns);

// EXTERNAL MODULE: ./src/utils/get-query-params.ts
var get_query_params = __webpack_require__(16731);
// EXTERNAL MODULE: ./src/components/Account/Logged/styles.module.scss
var Logged_styles_module = __webpack_require__(38663);
var Logged_styles_module_default = /*#__PURE__*/__webpack_require__.n(Logged_styles_module);
;// CONCATENATED MODULE: ./src/components/Account/Logged/index.tsx


















var Logged_cx = bind_default().bind((Logged_styles_module_default()));
function AccountContent(param) {
    var className = param.className, greeting = param.greeting, navigation = param.navigation, information = param.information, addressBook = param.addressBook, orders = param.orders, returns = param.returns;
    var locale = (0,useLocale/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var params = (0,react.useMemo)(function() {
        return (0,get_query_params/* getQueryParams */.vl)();
    }, [
        router
    ]);
    var ref = (0,react.useState)(Object.values(AccountNavigationSections).includes(params === null || params === void 0 ? void 0 : params.section) ? params.section : AccountNavigationSections.INFORMATION), section = ref[0], setSection = ref[1];
    var ref1 = (0,useGetCustomer/* useGetCustomer */._)(), customer = ref1.data;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var addOrderNumberParam = (params === null || params === void 0 ? void 0 : params.number) && section === AccountNavigationSections.ORDERS;
    var updateCurrentPathname = function() {
        router.push(constants/* SINGLE_ROUTES.account.href */.OG.account.href, "".concat(constants/* SINGLE_ROUTES.account.href */.OG.account.href, "?section=").concat(section).concat(addOrderNumberParam ? "&number=".concat(params.number) : ""), {
            shallow: true,
            locale: locale
        });
    };
    var renderSection = function(currentSection) {
        switch(currentSection){
            case AccountNavigationSections.ADDRESS_BOOK:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_AddressBook, (0,_object_spread/* default */.Z)({
                    className: Logged_cx((Logged_styles_module_default()).content, (Logged_styles_module_default()).full)
                }, addressBook));
            case AccountNavigationSections.ORDERS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrdersWrapper, (0,_object_spread/* default */.Z)({
                    className: Logged_cx((Logged_styles_module_default()).content, (Logged_styles_module_default()).full)
                }, orders));
            case AccountNavigationSections.RETURNS:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_Returns, (0,_object_spread/* default */.Z)({
                    className: Logged_cx((Logged_styles_module_default()).content, (Logged_styles_module_default()).full)
                }, returns));
            case AccountNavigationSections.INFORMATION:
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged_InformationAndChangePassword, {
                    className: (Logged_styles_module_default()).content,
                    customer: customer,
                    information: information
                });
        }
    };
    (0,react.useEffect)(function() {
        updateCurrentPathname();
    }, [
        section
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                greeting: greeting,
                name: customer === null || customer === void 0 ? void 0 : customer.firstName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: Logged_cx(className, (Logged_styles_module_default()).AccountContent, gridStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, (0,_object_spread/* default */.Z)({
                        className: (Logged_styles_module_default()).navigation,
                        activeSection: section,
                        setSection: setSection
                    }, navigation)),
                    renderSection(section)
                ]
            })
        ]
    });
}
/* harmony default export */ var Logged = (AccountContent);

// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
// EXTERNAL MODULE: ./src/hocs/withAuthentication.tsx
var withAuthentication = __webpack_require__(839);
;// CONCATENATED MODULE: ./src/pages/account/index.tsx





function AccountPage(param) {
    var accountPage = param.accountPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged, (0,_object_spread/* default */.Z)({}, accountPage)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "customers/account"
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var account = ((0,withAuthentication/* default */.Z)(AccountPage));


/***/ }),

/***/ 28181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FormTemplate":"styles_FormTemplate__4bKFC","submit":"styles_submit__pC_jX"};

/***/ }),

/***/ 5114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__6e9OI","spinner":"styles_spinner__Xp_RE"};

/***/ }),

/***/ 81001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AddressForm":"styles_AddressForm__fgFAi","title":"styles_title__qZ4kE","form":"styles_form__GIvmh"};

/***/ }),

/***/ 2144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AddressItem":"styles_AddressItem__Zp23p","placeHolderLink":"styles_placeHolderLink__7PkzV","wrapper":"styles_wrapper__oN9MY","content":"styles_content__Tiw3q","buttons":"styles_buttons__4dtjV","AddressPopin":"styles_AddressPopin__i_KRi","popin":"styles_popin__TbNqX"};

/***/ }),

/***/ 18287:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Addresses":"styles_Addresses__DSo2a","title":"styles_title__iRrvi","content":"styles_content__A3hYl","addresses":"styles_addresses__MMNmO","hideOnSmallScreen":"styles_hideOnSmallScreen__ur6i5","hideOnLargeScreen":"styles_hideOnLargeScreen__Asfsg","slider":"styles_slider__LmRwE","item":"styles_item__9Q2_q"};

/***/ }),

/***/ 89634:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"EmptySection":"styles_EmptySection__R2Fq9","title":"styles_title__0Hypj","cta":"styles_cta__ifE04"};

/***/ }),

/***/ 29305:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AccountHero":"styles_AccountHero__HTotJ","wrapper":"styles_wrapper__j2PdL"};

/***/ }),

/***/ 75142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Information":"styles_Information__eu9bu","form":"styles_form__fsInc","dateInput":"styles_dateInput__lyOjH","bottomRow":"styles_bottomRow__y_Kgi","saveButton":"styles_saveButton__V_3qX","reset":"styles_reset__m8V5L"};

/***/ }),

/***/ 27329:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2389:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LoadingSection":"styles_LoadingSection__UXAdf","spinner":"styles_spinner__Ft6GQ"};

/***/ }),

/***/ 94224:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AccountNavigation":"styles_AccountNavigation__X_sch","links":"styles_links___mdPw","link":"styles_link__Bszh3"};

/***/ }),

/***/ 73420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"OrderProducts":"styles_OrderProducts__l0mCk","product":"styles_product__VQ2tg","imageWrapper":"styles_imageWrapper__SCIPM","ratio":"styles_ratio__nOXEN","details":"styles_details__b8u6k","designer":"styles_designer__kaPpl","priceAndQuantity":"styles_priceAndQuantity__q0LMh","sizeWrapper":"styles_sizeWrapper___nSDN","size":"styles_size__PpGG4"};

/***/ }),

/***/ 14180:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"OrderDetails":"styles_OrderDetails__uDRuw","products":"styles_products__gKn3x","instructions":"styles_instructions__yzwSL","partialWrapper":"styles_partialWrapper__Vnpy3","partial":"styles_partial__ww8bc","spinner":"styles_spinner__gglr2","billing":"styles_billing__qQXuR","content":"styles_content__CL9OD"};

/***/ }),

/***/ 62170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"OrderHead":"styles_OrderHead__u_ghO","cta":"styles_cta___9SPU"};

/***/ }),

/***/ 40289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Orders":"styles_Orders__e3ndj","head":"styles_head__24e1t","row":"styles_row__cvqje","accordion":"styles_accordion__vyQco","orderDetails":"styles_orderDetails__5Wjts"};

/***/ }),

/***/ 57175:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Returns":"styles_Returns__Kgw4t","title":"styles_title__8ai01"};

/***/ }),

/***/ 84657:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"styles_SectionTitle__Uqq0O"};

/***/ }),

/***/ 38663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AccountContent":"styles_AccountContent__zyFWv","navigation":"styles_navigation__LsK23","content":"styles_content__J21Yw","wide":"styles_wide__I_CBA","full":"styles_full__t8s6e"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,5866,9523,9774,2888,179], function() { return __webpack_exec__(47017); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);